import { render, staticRenderFns } from "./Baizhi.vue?vue&type=template&id=3708adc9&"
import script from "./Baizhi.vue?vue&type=script&lang=js&"
export * from "./Baizhi.vue?vue&type=script&lang=js&"
import style0 from "./Baizhi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports